var $ = jQuery;
var run = false;
const homePage = {
  methods: {
    resize: () => {
      const playerWrapper = document.querySelector('.player--wrapper');
      const videoList = document.querySelector('.video--flex-bottom');

      if (playerWrapper && videoList) {
        if (window.innerWidth >= 1280) {
          const height = window.getComputedStyle(playerWrapper).height;
          videoList.style.height = height;
        } else {
          videoList.style.height = '';
        }
      }
    },
    slick: () => {
      const next = `<div class="slick-button-container next">
           <button type="button" data-role="none" class="slick-next slick-arrow next" aria-label="Next" role="button" style="">Next</button>
         </div>`;
      const prev = `<div class="slick-button-container prev">
          <button type="button" data-role="none" class="slick-prev slick-arrow prev" aria-label="Previous" role="button" style="">Previous</button>
         </div>`;

      $('.experts-slide--container')
        .not('.slick-initialized')
        .slick({
          dots: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          prevArrow: prev,
          nextArrow: next,
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
              },
            },
          ],
        });

      $('.featured-item-slide--container').not('.slick-initialized').slick({
        dots: true,
        prevArrow: prev,
        nextArrow: next,
      });

      $('.grid--slider-container').not('.slick-initialized').slick({
        dots: true,
        prevArrow: prev,
        nextArrow: next,
        asNavFor: '.grid--intro-container',
      });

      $('.grid--intro-container').not('.slick-initialized').slick({
        fade: true,
        arrows: false,
        asNavFor: '.grid--slider-container',
      });

      $('.yt--image-container').not('.slick-initialized').slick({
        dots: true,
        prevArrow: prev,
        nextArrow: next,
        asNavFor: '.yt--intro-container',
      });

      $('.yt--intro-container').not('.slick-initialized').slick({
        arrows: false,
        asNavFor: '.yt--image-container',
      });

      $('.event--image-container').not('.slick-initialized').slick({
        dots: true,
        prevArrow: prev,
        nextArrow: next,
        asNavFor: '.event--intro-container',
      });

      $('.event--intro-container').not('.slick-initialized').slick({
        arrows: false,
        asNavFor: '.event--image-container',
      });

      $('.podcast--image-container').not('.slick-initialized').slick({
        dots: true,
        prevArrow: prev,
        nextArrow: next,
        asNavFor: '.podcast--intro-container',
      });

      $('.podcast--intro-container').not('.slick-initialized').slick({
        arrows: false,
        asNavFor: '.podcast--image-container',
      });

      $('.mobile--latest-trending .left--container-top .view-content').not('.slick-initialized').slick({
        nextArrow: '.left--container-top .buttons--container .next-container',
        prevArrow: '.left--container-top .buttons--container .prev-container',
        slidesToShow: 2,
        slidesToScroll: 2,
      });

      $('.mobile--latest-trending .left--container-bottom .view-content').not('.slick-initialized').slick({
        nextArrow: '.left--container-bottom .buttons--container .next-container',
        prevArrow: '.left--container-bottom .buttons--container .prev-container',
        slidesToShow: 2,
        slidesToScroll: 2,
      });
    },
    tabs: () => {
      const top = document.querySelector('.top-tab');
      const all = document.querySelector('.all-tab');
      const showCont = (event, element) => {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName('tabcontent');
        for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = 'none';
        }
        tablinks = document.getElementsByClassName('tablinks');
        for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(' active', '');
        }
        document.querySelector(element).style.display = 'block';
        event.currentTarget.className += ' active';
      };
      if (!top && !all) return;
      top.addEventListener('click', event => {
        showCont(event, '.top-container');
      });
      all.addEventListener('click', event => {
        showCont(event, '.all-container');
      });
    },
    accordion: () => {
      const changeContext = (element, change) => {
        let sibling = element.nextElementSibling;
        if (!change) {
          element.parentNode.classList.remove('active');
          element.classList.remove('active');
          element.setAttribute('aria-expanded', false);
          sibling.setAttribute('aria-expanded', false);
          sibling.style.maxHeight = '';
        } else {
          element.parentNode.classList.add('active');
          element.classList.add('active');
          element.setAttribute('aria-expanded', true);
          sibling.setAttribute('aria-expanded', true);
          sibling.style.maxHeight = sibling.scrollHeight + 'px';
          window.addEventListener('resize', () => {
            if (element.classList.contains('active')) {
              sibling.style.maxHeight = sibling.scrollHeight + 'px';
            }
          });
        }
      };
      const acc = document.getElementsByClassName('accordion--button');
      for (let i = 0; i < acc.length; i++) {
        acc[i].nextElementSibling.setAttribute('id', 'accordion-' + i);
        acc[i].setAttribute('aria-controls', 'accordion-' + i);
        acc[i].addEventListener('click', function () {
          for (let i = 0; i < acc.length; i++) {
            if (this !== acc[i]) {
              changeContext(acc[i], false);
            }
          }
          if (this.classList.contains('active')) {
            changeContext(this, false);
          } else {
            changeContext(this, true);
          }
        });
      }
    },
    moveContainer: (oldCont, newCont) => {
      const oldContainer = [...document.querySelectorAll(oldCont)];
      if (oldContainer.length > 0) {
        $(oldContainer).appendTo($(newCont));
      }
    },
    issuesScroll: () => {
      if (window.innerWidth >= 1280) {
        // Set a static height on the 'All Issues' container.
        const allIssuesContainer = document.querySelector('.all-issues--container');
        if (allIssuesContainer) {
          allIssuesContainer.style.height = `${allIssuesContainer.offsetHeight + 10}px`;
        }
      }
    },
    donateButton: () => {
      const donate_btn = document.querySelector('.donate-btn');
      const become_member_btn = document.querySelector('.image-hero__cta.impact-cta .impact-cta-btn');
      let hasScrollEvent = false;
      
      function handleDonateBtn(){
          const become_member_btn_offset =  become_member_btn.getBoundingClientRect().bottom;
          if (become_member_btn_offset < 0 ) {
            donate_btn.classList.remove('inactive');
            donate_btn.classList.add('active');
          } else {
            donate_btn.classList.remove('active');
            donate_btn.classList.add('inactive');
          }
      }

      function handleDonateBtnOnResize(e){
        if (window.innerWidth >= 481) {
          handleDonateBtn();
          if (!hasScrollEvent) {
            window.addEventListener('scroll', handleDonateBtn);
            hasScrollEvent = true;
          }
        } else {
          donate_btn.classList.remove('active');
          donate_btn.classList.add('inactive');
          if (hasScrollEvent) {
            window.removeEventListener('scroll', handleDonateBtn);
            hasScrollEvent = false;
          }
        }
      }

      if(window.innerWidth > 480) {
        if(donate_btn) {
          window.addEventListener('load', handleDonateBtn);
          window.addEventListener('scroll', handleDonateBtn);
          window.addEventListener('resize', handleDonateBtnOnResize);
          hasScrollEvent = true;
        }
      }
    }
  },

  init: () => {
    window.addEventListener('resize', homePage.methods.resize);
    homePage.methods.moveContainer('.impact--content', '.grid--slider-container');
    homePage.methods.moveContainer('.impact--intro', '.grid--intro-container');
    homePage.methods.moveContainer(
      '.paragraph--type--homepage-young-item .grid--three-column-image',
      '.yt--image-container'
    );
    homePage.methods.moveContainer(
      '.paragraph--type--homepage-young-item .grid--three-column-intro',
      '.yt--intro-container'
    );
    homePage.methods.moveContainer(
      '.paragraph--type--homepage-event-item .grid--three-column-image',
      '.event--image-container'
    );
    homePage.methods.moveContainer(
      '.paragraph--type--homepage-event-item .grid--three-column-intro',
      '.event--intro-container'
    );
    homePage.methods.moveContainer(
      '.paragraph--type--homepage-podcast-item .grid--three-column-image',
      '.podcast--image-container'
    );
    homePage.methods.moveContainer(
      '.paragraph--type--homepage-podcast-item .grid--three-column-intro',
      '.podcast--intro-container'
    );
    homePage.methods.slick();
    homePage.methods.resize();
    homePage.methods.accordion();
    homePage.methods.tabs();
    homePage.methods.issuesScroll();
    homePage.methods.donateButton();
  },
};

// Load JS
const init = homePage.init;

export { init };
